"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiUtils = void 0;
const globals_1 = require("../infra/globals");
const date_utils_1 = require("../infra/date_utils");
const router_1 = require("../routing/router");
const country_1 = require("../models/country");
const game_event_1 = require("../models/game_event");
var UiUtils;
(function (UiUtils) {
    UiUtils.allFlags = (countries) => countries
        .map((c) => `
          <span title="${c.name}">
            ${(0, country_1.getFlag)(c.name)}
          </span>
        `)
        .reduce((pflag, cflag) => pflag + cflag);
    UiUtils.lastGameLink = (player) => {
        if (player.lastGame) {
            const lastGameDate = date_utils_1.DateUtils.formatDate(new Date(player.lastGame.date));
            return `
        <route-link 
          class="centered" 
          href="${router_1.RouteEnum.gameRecords}/${player.lastGame.firebaseRef}">
            <span>${lastGameDate}</span>
        </route-link>
      `;
        }
        else
            return `<span class="centered">${globals_1.emdash}</span>`;
    };
    UiUtils.playerPicture = (picture) => !picture
        ? `<span class="centered" id="picture-placeholder">${globals_1.emdash}</span>`
        : `<img id="picture" src="${picture}"/>`;
    UiUtils.signedEloDelta = (n) => n === 0 ? n.toString() : n > 0 ? `+${n}` : n.toString();
    UiUtils.gameEventLink = (gameRecord) => {
        let gameEvent = gameRecord.gameEvent?.type.toString();
        let gameEventLink = `<span>${gameEvent}</span>`;
        if (gameRecord.gameEvent && (0, game_event_1.isTournamentOrLeague)(gameRecord.gameEvent)) {
            gameEvent = gameRecord.gameEvent.name;
            gameEventLink = `
        <route-link 
          href="${router_1.RouteEnum.gameEvents}/${gameRecord.gameEventRef}">
            <span>${gameRecord.gameEvent.name}</span>
        </route-link>
      `;
        }
        return gameEventLink;
    };
})(UiUtils = exports.UiUtils || (exports.UiUtils = {}));
//# sourceMappingURL=data:application/json;base64,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